import { render } from "./CoursesDialog.vue?vue&type=template&id=117168ab"
import script from "./CoursesDialog.vue?vue&type=script&lang=js"
export * from "./CoursesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__